/**
 * Device Movement Mutations
 * React Query mutations สำหรับการย้ายอุปกรณ์ข้ามโครงการ
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import deviceMovementService, {
  TransferRequest,
  TransferResponse,
} from '../../services/deviceMovementService';
import { showError } from '../../utils/toast';
import { getApiErrorMessage } from '../../utils/mapFieldErrors';

/**
 * Hook สำหรับย้ายอุปกรณ์ทั้งสัญญาเช่าไปโครงการอื่น
 * warnings จาก response ให้ caller จัดการเอง (ผ่าน mutateAsync)
 */
export const useTransferRental = () => {
  const queryClient = useQueryClient();

  return useMutation<
    TransferResponse,
    Error,
    { rentalId: number; data: TransferRequest }
  >({
    mutationFn: ({ rentalId, data }) =>
      deviceMovementService.transferRental(rentalId, data),
    onSuccess: () => {
      // การย้ายแตะ rental.site_id + อาจ resolve ใบแจ้งยกเลิก + เปิด/ปิด site
      queryClient.invalidateQueries({ queryKey: ['rentals'] });
      queryClient.invalidateQueries({ queryKey: ['rental'] });
      queryClient.invalidateQueries({ queryKey: ['device-movements'] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
      // KD3 S2483: ข้อความสำเร็จอยู่ที่ผู้เรียก (DeviceMovementModal) — ย้ายบางรายการ/มีคำเตือนมีข้อความเฉพาะ
      // เดิมขึ้นที่นี่ด้วย → 2 toast ซ้อน (เขียว 'สำเร็จ' คู่กับส้ม 'มีข้อควรทราบ' = สัญญาณขัดกัน · SR อ่านซ้ำ)
    },
    onError: (error: Error) => {
      showError(getApiErrorMessage(error, 'เกิดข้อผิดพลาดในการย้ายอุปกรณ์'));
    },
  });
};

export default {
  useTransferRental,
};
